module.exports = __webpack_public_path__ + "static/media/h-gamepin.634c261d.png";